import Incoterms from ".";
import React from 'react'

export const incotermRoutes = [
  {
    path: "/incoterms",
    element: <Incoterms />,
  },
];
